import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import CatalogoOrganizacion from '../../catalogos/catalogoOrganizacion';
import CatalogoProveedorPresupuesto from '../../catalogos/catalogoProveedorm';
import CatalogoProveedor from '../../catalogos/catalogoProveedor';

export const ImprimirTrasladoListaCompromisoProveedor = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [mostrar4, setMostrar4] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [condi, setCondi] = useState('');
    const [cata, setCata] = useState(0);
    const [idorg, setIdorg] = useState('');
    const [nombreorg, setNombreorg] = useState('');
    const [riforg, setRiforg] = useState('');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtOrganismo = useRef();
    const txtTodosOrganismo = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();
    const txtProveedor = useRef();
    const txtTodosProveedores = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtDesde.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Desde no debe ir Vacio!', icono: 'informacion' });
            sigue = false;
            txtDesde.current.focus();
        } else if (txtHasta.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Hasta no debe ir Vacio!', icono: 'informacion' });
            sigue = false;
            txtHasta.current.focus();
        }

        else if (sigue) {
            imprimirGeneral(desde, hasta, condi)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'desde') {
            setDesde(e.target.value);
        } else if (e.target.id === 'hasta') {
            setHasta(e.target.value);
        }
    };

    const onCheck = () => {

        if (props.condicion === 'Traslado') {

            if (txtOrganismo.current.checked) {
                setCata(1);
                setActivo(true);
            } else if (txtTodosOrganismo.current.checked) {
                setActivo(false);
                setCata(0);
                setIdorg('');
                setNombreorg('');
                setRiforg('');
                setCondi("true");
            }

        } else if (props.condicion === 'Listado de Compromisos por Proveedor') {

            if (txtProveedor.current.checked) {
                setCata(2);
                setActivo(true);
            } else if (txtTodosProveedores.current.checked) {
                setActivo(false);
                setCata(0);
                setIdorg('');
                setNombreorg('');
                setRiforg('');
                setCondi("");
            }

        }


    }

    const imprimirGeneral = (desde, hasta, condic) => {

        var reporte = "";
        var sql = "";
        var sql1 = "";
        let desdec = moment.utc(desde).format('DD-MM-YYYY');
        let hastac = moment.utc(hasta).format('DD-MM-YYYY');
        var val = 0;

        if (props.condicion === 'Traslado') {

            reporte = 'Pres_SE_Traslado_b';

            sql = "Fecha Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";
            val = 1;

        } else if (props.condicion === 'Listado de Compromisos por Proveedor') {

            reporte = 'Pres_CompromisoProv';

            sql = "CPG.Fecha Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "' " + condic;
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA " + " " + "'" + hastac + "'";
            val = 2;

        }

        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&idfiscal=" + idefiscal + "&sql=" + sql + "&sql1=" + sql1 + "&sql2=" + condic + "&sql3=" + desdec + "&sql4=" + hastac + "&val=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtDesde.current.value = '';
        txtHasta.current.value = '';
        setActivo(true);
        setCata(0);
        setIdorg('');
        setNombreorg('');
        setRiforg('');
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const catalogoProvee = (e) => {
        e.preventDefault();
        setMostrar3(true);
    };

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const handleCancelara = () => {
        setMostrar3(false);
    }

    const handleAceptaOrganizacion = (id, rif, nombre, razon) => {
        setMostrar4(false);
        setActivo(false);
        setIdorg(id);
        setNombreorg(nombre);
        setRiforg(rif);
        setCondi("idorganismo = " + id);
    }

    const handleAceptaProveedor = (responsable, razonsocial, idproveedor, rif) => {
        setMostrar4(false);
        setActivo(false);
        setIdorg(idproveedor);
        setNombreorg(razonsocial);
        setRiforg(rif);
        setCondi("AND idproveedor = " + idproveedor);
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                txtDesde.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                txtHasta.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                setHasta(fech);
                setDesde(fech);
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir ' + props.condicion}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                {/*<CatalogoOrganizacion
                    show={mostrar4}
                    onHideCancelaCatOrg={handleCancelaras}
                    onHideAceptaCatOrg={handleAceptaOrganizacion}
                />*/}
                <CatalogoProveedor
                    show={mostrar4}
                    onHideCancelaCatProv={handleCancelaras}
                    onHideAceptaCatProv={handleAceptaOrganizacion}
                    tipo={4}
                />
                <CatalogoProveedorPresupuesto
                    show={mostrar3}
                    onHideCancelar={handleCancelara}
                    onHideAceptaProveedor={handleAceptaProveedor}
                />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                                <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-4 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Desde Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtDesde} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="desde" />
                                        </div>
                                    </div>

                                    <div className='col-sm-4 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Hasta Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtHasta} max={moment.utc(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="hasta" />
                                        </div>
                                    </div>

                                </div>


                                {props.condicion === 'Traslado' ? <div className='row m-0 col-sm-10 px-0 border-azul rounded py-2 mx-auto mb-2'>
                                    <div className="form-check col-md-4 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtOrganismo} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Seleccionar Organismo
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtTodosOrganismo} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Todos Los Organismo
                                        </label>
                                    </div>
                                </div> : <div className='row m-0 col-sm-10 px-0 border-azul rounded py-2 mx-auto mb-2'>
                                    <div className="form-check col-md-4 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtProveedor} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Seleccionar Proveedor
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 mx-auto mb-1">
                                        <input className="form-check-input" ref={txtTodosProveedores} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Todos Los Proveedores
                                        </label>
                                    </div>
                                </div>}

                                {cata === 1 ? <div className='col-md-12 m-0 px-0'>
                                    <table className="table">
                                        <thead>
                                            <tr className='text-center'>
                                                <th scope="col">ID</th>

                                                <th scope="col">NOMBRE</th>

                                                <th scope="col">RIF</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-bordered'>
                                            <tr className='text-center'>
                                                <td>{idorg}</td>

                                                <td>{nombreorg}</td>

                                                <td>{riforg}</td>

                                                <td><button onClick={catalogoClass} className="btn btn-sm  btn-info ml-2" ><i className="fa fa-search"></i> </button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> : cata === 2 ? <div className='col-md-12 m-0 px-0'>
                                    <table className="table">
                                        <thead>
                                            <tr className='text-center'>
                                                <th scope="col">ID</th>

                                                <th scope="col">RAZÓN SOCIAL</th>

                                                <th scope="col">RIF</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-bordered'>
                                            <tr className='text-center'>
                                                <td>{idorg}</td>

                                                <td>{nombreorg}</td>

                                                <td>{riforg}</td>

                                                <td><button onClick={catalogoProvee} className="btn btn-sm  btn-info ml-2" ><i className="fa fa-search"></i> </button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> : ''}

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}